<template>
    <form @submit.prevent="submit()">

        <div class="pt-0 mb-4">
            
            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="learners"
                    ref="learners"
                    :empty-text="$t('sessions.no-more-candidate')"
                    @select="learnerToggled">

                <el-table-column type="selection"
                    align="left"
                    min-width="120px">
                </el-table-column>

                <el-table-column width="72" class-name="avatar-cell">
                    <template v-slot="{row}">

                        <a href="#" class="avatar rounded-circle" @click.prevent="toggleLearner(row)">
                            <img alt="Image placeholder" :src="row.avatar">
                        </a>

                    </template>
                </el-table-column>

                <el-table-column class-name="name-cell">
                    <template v-slot="{row}">

                        <h4 class="mb-0">
                            <a href="#" @click.prevent="toggleLearner(row)">
                                {{ row.name }}
                            </a>
                        </h4>
                        <small v-if="row.owner">
                            {{ row.owner.name }}
                        </small>
                        <small v-if="row.entity">
                            / {{ row.entity.name }}
                        </small>

                    </template>
                </el-table-column>
                
            </el-table>
        </div>

        <div class="text-center" v-if="learners.length > 0">

            <base-button native-type="submit"
                type="primary"
                v-if="!errors.any()"
            >
                <span class="btn-inner--text">{{ $t('common.select') }}</span>
            </base-button>

            <base-button type="link" class="ml-auto" @click="modal.show = false">
                {{ $t('common.cancel') }}
            </base-button>
        </div>

    </form>
</template>

<script>
    export default {
        
        props: ['value', 'errors', 'modal', 'learners'],

        data() {
            return {
                learner: null,
            }
        },

        watch: {

            value(session) {
                this.$refs.learners.clearSelection();

                // Learner 1.
                this.learner = this.learners.find(learner => learner.id == session.teammate_id)
                this.$refs.learners.toggleRowSelection(this.learner);
            }
        },

        methods: {

            toggleLearner(learner) {

                // Clear errors.
                this.errors.clearAll()

                // Uncheck learner.
                if (this.learner && this.learner.id == learner.id) {
                    this.learner = null
                    this.$refs.learners.toggleRowSelection(learner, false)
                    return
                }

                // Check learner.
                if (!this.learner || this.learner.id != learner.id) {
                    this.$refs.learners.toggleRowSelection(this.learner, false)
                    this.learner = learner
                    this.$refs.learners.toggleRowSelection(learner, true)
                    return
                }
            },

            learnerToggled(selection) {

                // Clear errors.
                this.errors.clearAll()

                // Clear all.
                this.learner = null
                this.$refs.learners.clearSelection();

                // Keep the first.
                if (selection.length > 0) {
                    this.learner = selection[selection.length - 1]
                    this.$refs.learners.toggleRowSelection(this.learner, true)
                }
            },

            submit() {
                let newValue = { ...this.value}
                newValue.teammate_id = this.learner ? this.learner.id : null
                this.$emit('input', newValue)
            }
        }
    }
</script>

<style scoped>

    form >>> .avatar-cell {
        padding-right: 0;
    }
    form >>> .name-cell {
        padding-left: 1rem;
    }
    form >>> .el-table-column--selection .el-checkbox__inner {
        border: 1px solid #a5a8ad;
    }
    form >>> .el-table__empty-text {
        line-height: 1.5rem;
        width: 80%;
    }

</style>
